/******HOMEPAGE******/
/*PAGE*/
export default function Homepage() {
  /*DOM*/
  return (
    <div className="homepage ">
      <div className="mainText">
        <div className="mainLeft">
          <h2>Projet UNANÎMES : Université numérique avancée - DemoES</h2>
          <p>
            <strong>
              {" "}
              Nîmes Université est un jeune établissement qui s’engage dans
              le déploiement des techniques du numérique
            </strong>
            , en adoptant une approche globale au niveau de ses différentes
            missions et infrastructures : pédagogie, fonctionnement
            administratif, organisation de la vie de campus.
            <br />
            <br />
            <strong>
              Le programme numérique consiste à mettre en place une dynamique de
              numérique de l’établissement.{" "}
            </strong>
            Il s’agit d’apporter des outils facilitateurs du fonctionnement de
            la structure de réussite des étudiants, depuis leur accueil jusqu’à
            l’obtention de leur diplôme, et ce à tous niveaux.
            <br />
            <br />
            Les réalisations menées depuis plusieurs années et les retours
            d’expériences permettent de présenter un programme cohérent,
            crédible et partagé.{" "}
            <strong>
              Ce programme est pensé pour l’accueil, le bien-être et la réussite
              des étudiants à partir d’actions complémentaires :
            </strong>{" "}
          </p>

          <p className="myList">L’environnement d’apprentissage numérique.</p>

          <p className="myList">
            Les innovations numériques au service de la pédagogie.
          </p>

          <p className="myList">
            Les compétences et les capacités numériques des étudiant.e.s et du
            personnel.
          </p>
        </div>

        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/main.webp"
            className="logo"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>

      <div className="mainText mainText2">
        <div className="mainLeft">
          <p>
            <strong>
              Cette mutation concerne ainsi les infrastructures, le
              fonctionnement administratif et les nouvelles approches
              pédagogiques et leur appropriation
            </strong>
            .
            <br />
            <br />
            Nîmes Université travaille à offrir aux étudiant.e.s les
            dispositifs permettant des enseignements de la plus grande qualité
            possible, tout en rendant ces dispositifs pour tous et les plus
            imperméables possibles aux menaces et aléas extérieurs.
          </p>
        </div>
        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/main2.webp"
            className="logo"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>
    </div>
  );
}
